const texts = {
    appName: 'QR Code Generator',
}

export default texts;
